import React, { FC } from 'react';
import { Box } from 'grommet';
import { Copy } from 'grommet-icons';

import CollapsiblePanelBox from '../CollapsiblePanelBox';
import { ButtonWS, TextWS } from '../../config/grommetConfig';
import { useGame } from '../../contexts/gameContext';
import { copyToClipboard } from '../../helpers/copyToClipboard';
import { ALSO_PLAY_AT_TEXT, ALSO_PLAY_ON_TEXT } from '../../config/constants';

interface GameBoxProps {
  handleShowGameForm: () => void;
  setShowDeleteGameDialog: (show: boolean) => void;
}

const GameBox: FC<GameBoxProps> = ({
  handleShowGameForm: showGameForm,
  setShowDeleteGameDialog,
}) => {
  const { game } = useGame();

  const renderComms = () => {
    if (!!game?.commsUrl) {
      if (!!game.commsApp) {
        return (
          <Box>
            <TextWS>{`${ALSO_PLAY_ON_TEXT} ${game.commsApp}`}</TextWS>
            <TextWS truncate>{`at ${game.commsUrl}`}</TextWS>
          </Box>
        );
      } else {
        return (
          <Box>
            <TextWS>{`${ALSO_PLAY_AT_TEXT}:`}</TextWS>
            <TextWS truncate>{game.commsUrl}</TextWS>
          </Box>
        );
      }
    } else if (!!game?.commsApp) {
      return (
        <Box>
          <TextWS>{`${ALSO_PLAY_ON_TEXT} ${game.commsApp}`}</TextWS>
        </Box>
      );
    }
  };
  return (
    <CollapsiblePanelBox
      title={!!game ? game.name : 'Game'}
      onEdit={showGameForm}
    >
      <Box
        data-testid="game-box"
        fill="horizontal"
        justify="start"
        align="start"
        gap="12px"
        animation={{ type: 'fadeIn', delay: 0, duration: 500, size: 'xsmall' }}
      >
        <Box direction="row" align="center" gap="12px">
          {renderComms()}
          {game?.commsUrl && (
            <Copy
              color="accent-1"
              onClick={() => copyToClipboard(game.commsUrl)}
              cursor="pointer"
            />
          )}
        </Box>
        <ButtonWS
          label="DELETE GAME"
          secondary
          size="large"
          alignSelf="center"
          fill="horizontal"
          onClick={() => setShowDeleteGameDialog(true)}
        />
      </Box>
    </CollapsiblePanelBox>
  );
};

export default GameBox;
